export default function customiz() {

  // Change logo at scroll
  const header = document.querySelector('.js-sticky-menu');
  const logo = document.querySelector('.logo');

  if (header && logo) {
    const observer = new MutationObserver(() => {
      if (header.classList.contains('is-sticky')) {
        logo.src = logo.dataset.logoSticky;
      } else {
        logo.src = logo.dataset.logo;
      }
    });

    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  // Resize hero default image
  function setHeroImage(container, heroImage) {
    var viewportWidth = document.documentElement.clientWidth;
    var rect = container.getBoundingClientRect();
    var rightOffset = viewportWidth - rect.right;

    heroImage.style.right = rightOffset + 'px';
    heroImage.style.width = (viewportWidth - rect.left - rect.width / 2 - rightOffset) + 'px';
    heroImage.classList.add('is-ready');
  }

  function initHeroImages() {
      var heroes = document.querySelectorAll('.hero, .hero-article');

      heroes.forEach(function(hero) {
          var container = hero.querySelector('.container');
          var heroImage = hero.querySelector('.hero__image');
          if (!container || !heroImage) return;

          setHeroImage(container, heroImage);
      });
  }

  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroImages);
  } else {
      initHeroImages();
  }
  window.addEventListener('resize', initHeroImages);

  // FacetWP - Références
  jQuery(document).ready(function ($) {
    if (!document.body.classList.contains('post-type-archive-reference')) {
      return;
    }

    jQuery(".facetwp-facet").hide();

    jQuery(".filtre .titre").click(function () {
      var $facet = jQuery(this).next(".facetwp-facet");
      $facet.toggle();
      jQuery(this).toggleClass("open");
    });
  });

  // Button facet reset
  jQuery(document).ready(function () {
    jQuery(document).on("facetwp-loaded", function () {
      var selections = FWP.buildQueryString();
      if ("" === selections) {
        console.log("Aucune sélection");
        jQuery(".facet-reset").hide();
      } else {
        jQuery(".facet-reset").show();
      }
    });
  });

  var titre = jQuery('.titre');
  jQuery.each(titre, function (index, value) {
    var html = value.innerHTML;
    var replace = html.replace("['", "<span class='highlight'>").replace("']", "</span>");
    value.innerHTML = replace;
  });

  // Menu mobile
  jQuery(document).on("click", ".js-open-menu", function () {
    jQuery(".js-slide-menu").addClass("active");
    jQuery("body").addClass("menu-is-open");
  });

  // Sticky menu au scroll
  var menu = jQuery('.js-sticky-menu');
  if (!menu.length) return;

  var stickyClass = 'is-sticky';
  function onScroll() {
    if (window.scrollY > 8) {
      menu.addClass(stickyClass);
    } else {
      menu.removeClass(stickyClass);
    }
  }

  onScroll(); // état initial correct si on arrive déjà scrollé
  jQuery(window).on('scroll', onScroll);


  jQuery(document).on("click", ".js-close-menu", function () {
    jQuery(".js-slide-menu").removeClass("active");
    jQuery("body").removeClass("menu-is-open");
  });

  var ElementWithChild = jQuery('.slide-menu .menu-item-has-children');
  ElementWithChild.each(function () {
    var Parent = jQuery(this).find('.has-children-wrapper a, .has-children-wrapper p').text();
    jQuery(this).children('.sub-menu').prepend(
      '<li class="menu-item"><a class="go-parent nav-link js-return-parent">' + Parent + '</a></li>'
    );
  });

  jQuery(".js-mobile-menu").on('click', function () {
    jQuery(".js-slide-menu").addClass("active");
    jQuery(".js-close-slide").addClass("active");
    jQuery("body").addClass("menu-is-open");
  });

  jQuery(".js-close-slide").on('click', function () {
    jQuery("body").removeClass("menu-is-open");
    jQuery(".js-slide-menu").removeClass("active");
    jQuery(".js-close-slide").removeClass("active");
  });

  jQuery(".js-open-sub-menu").on('click', function (e) {
    e.preventDefault();
    var sub = jQuery(this).parent().parent().find(".sub-menu:first");
    sub.addClass("active");
  });

  jQuery(".js-return-parent").on('click', function () {
    jQuery(this).parent().parent().removeClass("active");
  });

  // Archive implantation - Searchbar by postcode
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('post-type-archive-implantation')) {
      return;
    }

    const form = document.getElementById('postcode-form');
    const input = document.getElementById('postcode-input');
    const errorDiv = document.getElementById('postcode-error');

    const cpToRegionSlug = {
      // Auvergne-Rhône-Alpes (01 à 15, 26, 38, 42, 43, 63, 69, 73, 74)
      '01000': 'auvergne-rhone-alpes', '03000': 'auvergne-rhone-alpes', '07000': 'auvergne-rhone-alpes',
      '15000': 'auvergne-rhone-alpes', '26000': 'auvergne-rhone-alpes', '38000': 'auvergne-rhone-alpes',
      '42000': 'auvergne-rhone-alpes', '43000': 'auvergne-rhone-alpes', '63000': 'auvergne-rhone-alpes',
      '69000': 'auvergne-rhone-alpes', '73000': 'auvergne-rhone-alpes', '74000': 'auvergne-rhone-alpes',

      // Bourgogne-Franche-Comté (21, 25, 39, 58, 70, 71, 89, 90)
      '21000': 'bourgogne-franche-comte', '25000': 'bourgogne-franche-comte', '39000': 'bourgogne-franche-comte',
      '58000': 'bourgogne-franche-comte', '70000': 'bourgogne-franche-comte', '71000': 'bourgogne-franche-comte',
      '89000': 'bourgogne-franche-comte', '90000': 'bourgogne-franche-comte',

      // Bretagne (22, 29, 35, 56)
      '22000': 'bretagne', '29000': 'bretagne', '35000': 'bretagne', '56000': 'bretagne',

      // Centre-Val de Loire (18, 28, 36, 37, 41, 45)
      '18000': 'centre-val-de-loire', '28000': 'centre-val-de-loire', '36000': 'centre-val-de-loire',
      '37000': 'centre-val-de-loire', '41000': 'centre-val-de-loire', '45000': 'centre-val-de-loire',

      // Corse (2A = 20000, 2B = 20200)
      '20000': 'corse', '20200': 'corse',

      // Grand Est (08, 10, 51, 52, 54, 55, 57, 67, 68, 88)
      '08000': 'grand-est', '10000': 'grand-est', '51000': 'grand-est', '52000': 'grand-est',
      '54000': 'grand-est', '55000': 'grand-est', '57000': 'grand-est', '67000': 'grand-est',
      '68000': 'grand-est', '88000': 'grand-est',

      // Hauts-de-France (02, 59, 60, 62, 80)
      '02000': 'hauts-de-france', '59000': 'hauts-de-france', '60000': 'hauts-de-france', '62000': 'hauts-de-france',
      '80000': 'hauts-de-france',

      // Île-de-France (75, 77, 78, 91, 92, 93, 94, 95)
      '75000': 'ile-de-france', '77000': 'ile-de-france', '78000': 'ile-de-france', '91000': 'ile-de-france',
      '92000': 'ile-de-france', '93000': 'ile-de-france', '94000': 'ile-de-france', '95000': 'ile-de-france',

      // Normandie (14, 27, 50, 61, 76)
      '14000': 'normandie', '27000': 'normandie', '50000': 'normandie', '61000': 'normandie',
      '76000': 'normandie',

      // Nouvelle-Aquitaine (16, 17, 19, 23, 24, 33, 40, 47, 64, 79, 86, 87)
      '16000': 'nouvelle-aquitaine', '17000': 'nouvelle-aquitaine', '19000': 'nouvelle-aquitaine', '23000': 'nouvelle-aquitaine',
      '24000': 'nouvelle-aquitaine', '33000': 'nouvelle-aquitaine', '40000': 'nouvelle-aquitaine', '47000': 'nouvelle-aquitaine',
      '64000': 'nouvelle-aquitaine', '79000': 'nouvelle-aquitaine', '86000': 'nouvelle-aquitaine', '87000': 'nouvelle-aquitaine',

      // Occitanie (09, 11, 12, 30, 31, 32, 34, 46, 48, 65, 66, 81, 82)
      '09000': 'occitanie', '11000': 'occitanie', '12000': 'occitanie', '30000': 'occitanie', '31000': 'occitanie',
      '32000': 'occitanie', '34000': 'occitanie', '46000': 'occitanie', '48000': 'occitanie', '65000': 'occitanie',
      '66000': 'occitanie', '81000': 'occitanie', '82000': 'occitanie',

      // Pays de la Loire (44, 49, 53, 72, 85)
      '44000': 'pays-de-la-loire', '49000': 'pays-de-la-loire', '53000': 'pays-de-la-loire', '72000': 'pays-de-la-loire',
      '85000': 'pays-de-la-loire',

      // Provence-Alpes-Côte d’Azur (04, 05, 06, 13, 83, 84)
      '04000': 'provence-alpes-cote-dazur', '05000': 'provence-alpes-cote-dazur', '06000': 'provence-alpes-cote-dazur',
      '13000': 'provence-alpes-cote-dazur', '83000': 'provence-alpes-cote-dazur', '84000': 'provence-alpes-cote-dazur',

      // DOM
      '97100': 'guadeloupe', '97200': 'martinique', '97300': 'guyane', '97400': 'la-reunion', '97600': 'mayotte',

      // Ajout des départements à 2 chiffres (ils pointent vers les mêmes régions)
      '01': 'auvergne-rhone-alpes', '03': 'auvergne-rhone-alpes', '07': 'auvergne-rhone-alpes', '15': 'auvergne-rhone-alpes',
      '26': 'auvergne-rhone-alpes', '38': 'auvergne-rhone-alpes', '42': 'auvergne-rhone-alpes', '43': 'auvergne-rhone-alpes',
      '63': 'auvergne-rhone-alpes', '69': 'auvergne-rhone-alpes', '73': 'auvergne-rhone-alpes', '74': 'auvergne-rhone-alpes',

      '21': 'bourgogne-franche-comte', '25': 'bourgogne-franche-comte', '39': 'bourgogne-franche-comte', '58': 'bourgogne-franche-comte',
      '70': 'bourgogne-franche-comte', '71': 'bourgogne-franche-comte', '89': 'bourgogne-franche-comte', '90': 'bourgogne-franche-comte',

      '22': 'bretagne', '29': 'bretagne', '35': 'bretagne', '56': 'bretagne',

      '18': 'centre-val-de-loire', '28': 'centre-val-de-loire', '36': 'centre-val-de-loire', '37': 'centre-val-de-loire',
      '41': 'centre-val-de-loire', '45': 'centre-val-de-loire',

      '2A': 'corse', '2B': 'corse',

      '08': 'grand-est', '10': 'grand-est', '51': 'grand-est', '52': 'grand-est', '54': 'grand-est', '55': 'grand-est',
      '57': 'grand-est', '67': 'grand-est', '68': 'grand-est', '88': 'grand-est',

      '02': 'hauts-de-france', '59': 'hauts-de-france', '60': 'hauts-de-france', '62': 'hauts-de-france', '80': 'hauts-de-france',

      '75': 'ile-de-france', '77': 'ile-de-france', '78': 'ile-de-france', '91': 'ile-de-france', '92': 'ile-de-france',
      '93': 'ile-de-france', '94': 'ile-de-france', '95': 'ile-de-france',

      '14': 'normandie', '27': 'normandie', '50': 'normandie', '61': 'normandie', '76': 'normandie',

      '16': 'nouvelle-aquitaine', '17': 'nouvelle-aquitaine', '19': 'nouvelle-aquitaine', '23': 'nouvelle-aquitaine',
      '24': 'nouvelle-aquitaine', '33': 'nouvelle-aquitaine', '40': 'nouvelle-aquitaine', '47': 'nouvelle-aquitaine',
      '64': 'nouvelle-aquitaine', '79': 'nouvelle-aquitaine', '86': 'nouvelle-aquitaine', '87': 'nouvelle-aquitaine',

      '09': 'occitanie', '11': 'occitanie', '12': 'occitanie', '30': 'occitanie', '31': 'occitanie', '32': 'occitanie',
      '34': 'occitanie', '46': 'occitanie', '48': 'occitanie', '65': 'occitanie', '66': 'occitanie', '81': 'occitanie',
      '82': 'occitanie',

      '44': 'pays-de-la-loire', '49': 'pays-de-la-loire', '53': 'pays-de-la-loire', '72': 'pays-de-la-loire',
      '85': 'pays-de-la-loire',

      '04': 'provence-alpes-cote-dazur', '05': 'provence-alpes-cote-dazur', '06': 'provence-alpes-cote-dazur',
      '13': 'provence-alpes-cote-dazur', '83': 'provence-alpes-cote-dazur', '84': 'provence-alpes-cote-dazur',

      '971': 'guadeloupe', '972': 'martinique', '973': 'guyane', '974': 'la-reunion', '976': 'mayotte'
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorDiv.textContent = ''
      const cp = input.value.trim();

      const applyRegionFacet = (regionSlug) => {
        const facetName = 'implantation';

        const run = () => {
          const el = document.querySelector(
            `.facetwp-facet-${facetName} .facetwp-radio[data-value="${CSS.escape(regionSlug)}"]`
          );

          if (!el) {
            errorDiv.textContent = "Aucune agence trouvée pour ce code postal.";
            return;
          }

          // clic = FacetWP gère l'état + ajoute la classe checked
          el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        };

        // si la facet n'est pas encore rendue/active, on attend facetwp-loaded
        if (!document.querySelector(`.facetwp-facet-${facetName}`)) {
          document.addEventListener('facetwp-loaded', function once() {
            document.removeEventListener('facetwp-loaded', once);
            run();
          });
          return;
        }

        run();
      };

      if (/^\d{5}$/.test(cp)) {
        // Si un code postal complet est saisi (5 chiffres)
        let prefix = cp.substring(0, 2);
        if (cp.startsWith('97') || cp.startsWith('98')) {
          prefix = cp.substring(0, 3);
        }

        const lookupKey = `${prefix}000`;
        const regionSlug = cpToRegionSlug[lookupKey];

        if (regionSlug) {
          // Mettre à jour la facette
          applyRegionFacet(regionSlug);
        } else {
          errorDiv.textContent = "Aucune agence trouvée pour ce code postal.";
        }
      } else if (/^\d{2}$/.test(cp)) {
        // Si un numéro de département est saisi (2 chiffres)
        const regionSlug = cpToRegionSlug[cp];

        if (regionSlug) {
          applyRegionFacet(regionSlug);
        } else {
          errorDiv.textContent = "Aucune agence trouvée pour ce département.";
        }
      } else {
        errorDiv.textContent = "Merci de saisir un code postal valide.";
      }
    });
  });

  // FacetWP helper (attendre facetwp-loaded + appliquer une valeur proprement)
  (function ($) {
    const facetName = 'implantation';

    window.WIA_applyRegionFacet = function (regionValue) {
      if (!window.FWP) return;
      FWP.facets[facetName] = regionValue ? [regionValue] : [];
      FWP.refresh();
    };
  })(jQuery);

  // Obfuscation des liens
  jQuery('.js-obf-link').on('click', function () {
    var dest = jQuery(this).data('link');
    var target = jQuery(this).data('target');
    var decodeDest = atob(dest);

    if (target == '_blank') {
      window.open(decodeDest, '_blank');
    } else {
      window.location.href = decodeDest;
    }
  });

  (function ($) {

    // Module texte resize iframe on mobile
    document.addEventListener("DOMContentLoaded", function () {
      const container = document.querySelector(".m-texte");
      if (!container) return;

      const iframe = container.querySelector("iframe");
      if (!iframe) return;

      const updateIframeHeight = () => {
        const isMobile = window.innerWidth < 992;
        iframe.style.height = isMobile ? "300px" : "700px";
      };

      updateIframeHeight();
      window.addEventListener("resize", updateIframeHeight);
    });

    // Module Boucle (Version 2)
    const grid = document.querySelector('.grid');
    if (!grid) return;

    const mq = window.matchMedia('(max-width: 575.98px)');
    let msnry = null;

    function enableMasonry() {
      if (msnry) return;
      msnry = new Masonry(grid, {
        stamp: '.stamp',
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        horizontalOrder: true,
        gutter: 24,
        percentPosition: true
      });
      imagesLoaded(grid).on('progress', () => msnry.layout());
    }

    function disableMasonry() {
      if (!msnry) return;
      msnry.destroy();
      msnry = null;
      // Nettoyage styles inline
      grid.style.height = '';
      grid.querySelectorAll('.grid-item, .stamp').forEach(el => {
        el.style.position = '';
        el.style.left = '';
        el.style.top = '';
        el.style.transform = '';
      });
    }

    function syncByBreakpoint() {
      if (mq.matches) {
        disableMasonry(); // Mobile OFF
      } else {
        enableMasonry();  // Desktop/Tablet ON
      }
    }

    window.addEventListener('load', syncByBreakpoint);
    window.addEventListener('resize', debounce(syncByBreakpoint, 150));

    function debounce(fn, wait) {
      let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
    }

    // Archive expertise - Animation
    document.addEventListener("DOMContentLoaded", function () {
      const navLinks = document.querySelectorAll('.nav-link');
      const sections = document.querySelectorAll('.categorie');

      const sectionMap = new Map();

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          sectionMap.set(entry.target, entry.intersectionRatio);
        });

        // Get section more visible
        const mostVisible = [...sectionMap.entries()]
          .filter(([_, ratio]) => ratio > 0)
          .sort((a, b) => b[1] - a[1])[0];

        if (mostVisible) {
          const slug = mostVisible[0].getAttribute('data-slug');
          navLinks.forEach(link => {
            link.classList.toggle('active', link.dataset.slug === slug);
          });
        }
      }, {
        threshold: [0, 0.25, 0.5, 0.75, 1],
        rootMargin: '0px 0px -30% 0px'
      });

      sections.forEach(section => observer.observe(section));
    });

    // Style titre
    var titre = $('.titre');
    $.each(titre, function (index, value) {
      var html = value.innerHTML;
      var replace = html.replace("['", "<span class='highlight'>").replace("']", "</span>");
      value.innerHTML = replace;
    });

    // Module "Vidéo + Texte"
    var playerParams = '&autoplay=1&controls=0';
    if (window.matchMedia("(max-width: 765px)").matches) {
      var playerParams = '&autoplay=1&controls=1';
    }
    if (window.matchMedia("(min-width: 576px)").matches) {
      $(document).on("click", ".m-video-texte .m-video-texte_btn", function () {
        var wrap = $(this).next('.ratio');
        var iframe = $(this).next('.ratio').find('iframe');
        var parent = $(this).parent('.m-video-texte_video');
        var poster = parent.find('.img-fluid');

        if (!$(this).hasClass('hidden')) {
          $(this).addClass('hidden');
          poster.addClass('hidden');
          parent.addClass('play');
          wrap.html('<iframe title="" width="' + iframe.attr('width') + '" height="' + iframe.attr('height') + '" src="' + iframe.attr('src') + playerParams + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;" allowfullscreen="true" frameborder="0"></iframe>');
        } else {
          $(this).removeClass('hidden');
          poster.removeClass('hidden');
          parent.removeClass('play');
          var src = iframe.attr('src');
          wrap.html('<iframe title="" width="' + iframe.attr('width') + '" height="' + iframe.attr('height') + '" src="' + src.replace(playerParams, '') + '"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;" allowfullscreen="true" frameborder="0"></iframe>');
        }
      });
    }

    // Style titre 
    var titre = $('.titre');
    $.each(titre, function (index, value) {
      var html = value.innerHTML;
      var replace = html.replace("['", "<span class='vert'>").replace("']", "</span>");
      value.innerHTML = replace;
    });

    /////////////////////////////////////////////////////////////////////////////////////////////
    // Afichage des téléphones
    $(".js-phone-reveal").on("click", function () {
      $(this).find("span").text($(this).data("number"));
    });

    //annuler bouton tel sauf sur mobile
    /*jshint scripturl:true*/
    var $window = $(window);

    function checkWidth() {
      var windowsize = $window.width();
      if (windowsize > 767) {
        $(".js-phone-reveal").attr("href", "javascript:void(0)");
      }
    }

    // Execute on load
    checkWidth();

    ///////////////////////////////
    // activation totop
    ///////////////////////////////
    var offset = 300,
      offset_opacity = 1200,
      scroll_top_duration = 700,
      $back_to_top = $(".totop");

    //hide or show the "back to top" link
    $(window).on("scroll", function () {
      $(this).scrollTop() > offset
        ? $back_to_top.addClass("cd-is-visible")
        : $back_to_top.removeClass("cd-is-visible cd-fade-out");
      if ($(this).scrollTop() > offset_opacity) {
        $back_to_top.addClass("cd-fade-out");
      }
    });

    //smooth scroll to top
    $back_to_top.on("click", function (event) {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        scroll_top_duration
      );
    });

    ////////////////////////////////////
    // Copy current URL to clipboard
    // Au clic sur ".js-copy-to-clipboard"
    ///////////////////////////////////
    var $inputTemp = $("<input>");
    var $url = $(location).attr('href');

    $('.js-copy-to-clipboard').on('click', function () {
      $("body").append($inputTemp);
      $inputTemp.val($url).select();
      document.execCommand("copy");
      $inputTemp.remove();
      //console.log('url copié');
    })

    ///////////////////////////////
    // Is in view ?
    ///////////////////////////////
    var elementInView = $(".js-in-view");
    $(document).ready(function () {
      $.each(elementInView, function (i, element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          if (!$(element).hasClass("visible")) {
            $(element).addClass("visible");
          }
        } else {
          $(element).addClass("invisible");
        }
      });
    });
    $(window).on("scroll", function () {
      $.each(elementInView, function (i, element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          if (!$(element).hasClass("in-view")) {
            $(element).addClass("in-view");
            $(element).removeClass("invisible");
          }
        }
      });
    });

  })(jQuery);
}
